import {
    APP_INITIALIZER,
    ApplicationConfig,
    ErrorHandler,
    importProvidersFrom,
    LOCALE_ID,
    provideZoneChangeDetection
} from '@angular/core';
import { provideRouter, Router, withInMemoryScrolling, withRouterConfig } from '@angular/router';
import localeEl from '@angular/common/locales/el';

import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideToastr } from "ngx-toastr";
import {
    LocalStorageService,
    provideNgxWebstorage,
    withLocalStorage,
    withNgxWebstorageConfig,
    withSessionStorage
} from "ngx-webstorage";
import {
    HTTP_INTERCEPTORS,
    HttpClient,
    provideHttpClient,
    withFetch,
    withInterceptorsFromDi
} from "@angular/common/http";
import { HttpRequestsInterceptor } from "./core/interceptors/http-requests.interceptor";
import { registerLocaleData } from "@angular/common";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslationLoader } from "./core/classes/TranslationLoader";
import { provideMomentDateAdapter } from "@angular/material-moment-adapter";
import { MAT_DATE_LOCALE } from "@angular/material/core";
import * as Sentry from '@sentry/angular';
import { provideLottieOptions } from 'ngx-lottie';
import player from 'lottie-web';
import {
    DevTools,
    NgxTolgeeModule,
    Tolgee,
    TOLGEE_INSTANCE,
    FormatSimple
} from '@tolgee/ngx';
registerLocaleData(localeEl, 'el');
export function LocaleFactory(ls: LocalStorageService): TranslateLoader {
    return ls.retrieve('preferred_lang') || 'en';
}

export function HttpLoaderFactory(http: HttpClient, ls: LocalStorageService): TranslateLoader {
    return new TranslationLoader(http, ls, { cache: true });
}

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(routes,
             withInMemoryScrolling({
            scrollPositionRestoration: 'top',
            anchorScrolling: 'disabled',
        })
    //           withRouterConfig({
    //     onSameUrlNavigation: 'reload'
    //   })
    ),
        { provide: LOCALE_ID, useFactory: LocaleFactory, deps: [LocalStorageService] },
        { provide: MAT_DATE_LOCALE, useFactory: LocaleFactory, deps: [LocalStorageService] },
        // provideClientHydration(), // TODO enable this if we re enable SSR
        provideAnimationsAsync(),
        provideMomentDateAdapter(),
        provideToastr(),
        provideNgxWebstorage(
            withNgxWebstorageConfig({ separator: '', caseSensitive: true, prefix: '' }),
            withLocalStorage(),
            withSessionStorage()
        ),
        provideHttpClient(withFetch(), withInterceptorsFromDi()),
        { provide: HTTP_INTERCEPTORS, useClass: HttpRequestsInterceptor, multi: true },
        importProvidersFrom(
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useFactory: HttpLoaderFactory,
                    deps: [HttpClient, LocalStorageService]
                }
            })
        ),
        {
            provide: ErrorHandler,
            useValue: Sentry.createErrorHandler(),
        },
        {
            provide: Sentry.TraceService,
            deps: [Router],
        },
        {
            provide: APP_INITIALIZER,
            useFactory: () => () => { },
            deps: [Sentry.TraceService],
            multi: true,
        },
        provideLottieOptions({
            player: () => player,
        }),
        {
            provide: TOLGEE_INSTANCE,
            useFactory: (ls: LocalStorageService) => {
                const tolgee = Tolgee()
                    .use(DevTools())
                    .use(FormatSimple())
                    // replace with .use(FormatIcu()) for rendering plurals, foramatted numbers, etc.
                    .init({
                        defaultLanguage: 'en',
                        // Restore the visitor's last choice so a reload keeps the language.
                        language: ls.retrieve('preferred_lang') || 'en',
                        availableLanguages: ['en', 'el'],
                        // No Tolgee project/API key yet: translations are read from
                        // src/assets/i18n/<lang>.json. These are served as static
                        // assets, so copy can be edited without a rebuild.
                        // When a project exists, add apiUrl/apiKey back — these
                        // files then act as the offline fallback and no template
                        // or key has to change.
                        staticData: {
                            en: () => fetch('assets/i18n/en.json').then(r => r.json()),
                            el: () => fetch('assets/i18n/el.json').then(r => r.json()),
                        },
                    });
                            tolgee.run(); // ✅ crucial line: starts the engine
        return tolgee;
            },
            deps: [LocalStorageService],
        },
    ]
};
